import { React, useRef, useState } from "react";
import { login } from "../../data/api";
import "../../scss/pages/loginmodal.scss";
import mobile from "../../assets/mobile.png";

import "../../scss/pages/form.scss";
import { Alert, Modal } from "react-bootstrap";
import { MdErrorOutline } from "react-icons/md";
import Token from "../../utils/useToken";
import { useNavigate, useLocation } from "react-router";
import { AiOutlineEyeInvisible } from "react-icons/ai";
import Captcha from "../include/captcha";

const LoginModal = ({ Show, setShow, link }) => {
   //Set password and username and show password use state
   const [showPassword, setshowPassword] = useState(false);
   const [Password, setPassword] = useState("");
   const [number, setNumber] = useState("");
   const [ErrorMessage, setErrorMessage] = useState("");
   const [ErrorStatus, setErrorStatus] = useState(false);
   const [rememberMe, setRememberMe] = useState(false);
   const { setToken } = Token();
   let navigate = useNavigate();
   let location = useLocation();
   const reRef = useRef();

   //setting up Auth Context

   //for button state
   var btn_state = false;
   //used to login and store access token and refresh token
   const handleSubmit = async (e) => {
      btn_state = true;
      e.preventDefault();
      const captchaToken = process.env.REACT_APP_ISRECAPTCHA
         === "true" ? await reRef?.current?.executeAsync() : null;
      // console.log("Token", captchaToken);
      const response = await login(
         number?.length > 10
            ? number?.slice(0, 4) === "+977"
               ? number?.slice(4, 18)
               : number
            : number,
         Password,
         rememberMe,
         captchaToken,
      );
      if (response.statusText === "OK") {
         const accessToken = response.data.token.accessToken;
         const refreshToken = response.data.token.refreshToken;
         const expiresIn = response.data.token.expiresIn;
         const user = response.data.user;
         // setting accessToken and RefreshToken
         setToken({ accessToken, refreshToken, expiresIn, user });
         //navigating to home page
         if (link === location.pathname) {
            window.location.reload();
         } else {
            navigate(link);
         }

         setShow(false);
      } else {
         setErrorStatus(true);
         setErrorMessage(response.response.data.message);
      }
   };

   return (
      <Modal
         show={Show}
         onHide={() => {
            setShow(false);
         }}
      >
         <Modal.Body className="px-4 py-5">
            <div className={"Login_Wrapper mt-2"}>
               <div className={"Login_Modal"}>
                  <div className={"Login_Container"}>
                     <Alert
                        variant="danger"
                        className={"Login_Alert" + (ErrorStatus ? "_show" : "")}
                     >
                        <MdErrorOutline />
                        &nbsp;&nbsp;
                        {ErrorMessage}
                     </Alert>
                     <h1 className={"Login_Header"}>Login to DishHome</h1>
                     <h3 className={"Register_Header"}>
                        Don't have an account? <a href="/signup">Register</a>
                     </h3>
                     <label htmlFor="number">Phone Number</label>
                     <input
                        type="tel"
                        name="number"
                        className={"Number_Input"}
                        placeholder=""
                        value={number}
                        maxLength={14}
                        required
                        onChange={(e) => {
                           if (e?.nativeEvent?.data) {
                              if (e?.nativeEvent?.data?.toString()?.match("[0-9+\b]")) {
                                 setNumber(e.target?.value);
                              }
                              if (e?.nativeEvent?.data === null) {
                                 setNumber(e?.target?.value);
                              }
                           } else {
                              setNumber(e?.target?.value);
                           }
                        }}
                     />
                     <div className={"Password_Container"}>
                        <label htmlFor="password">Password</label>
                        <input
                           type={showPassword ? "text" : "password"}
                           name="password"
                           className={"Password_Input"}
                           placeholder=""
                           required
                           onChange={(e) => setPassword(e.target.value)}
                           onPaste={(e) => {
                              e.preventDefault();
                              return false;
                           }}
                           onKeyPress={(e) => {
                              if (e.charCode === 13) {
                                 handleSubmit(e);
                              }
                           }}
                        />
                        {!showPassword && (
                           <AiOutlineEyeInvisible
                              size={19}
                              className={"Pw_Icon"}
                              onClick={() => setshowPassword(!showPassword)}
                              style={{ top: "38px" }}
                           />
                        )}
                        {showPassword && (
                           <span
                              className={"Pw_Icon"}
                              onClick={() => setshowPassword(!!showPassword)}
                           >
                              <svg
                                 width="16"
                                 height="16"
                                 viewBox="0 0 16 16"
                                 fill="none"
                                 xmlns="http://www.w3.org/2000/svg"
                              >
                                 <path
                                    d="M8.00002 2C11.5947 2 14.5854 4.58667 15.2127 8C14.586 11.4133 11.5947 14 8.00002 14C4.40535 14 1.41469 11.4133 0.787354 8C1.41402 4.58667 4.40535 2 8.00002 2ZM8.00002 12.6667C9.35967 12.6664 10.6789 12.2045 11.7419 11.3568C12.8049 10.509 13.5486 9.32552 13.8514 8C13.5475 6.67554 12.8033 5.49334 11.7404 4.64668C10.6776 3.80003 9.35889 3.33902 8.00002 3.33902C6.64115 3.33902 5.32248 3.80003 4.2596 4.64668C3.19673 5.49334 2.45253 6.67554 2.14869 8C2.45142 9.32552 3.19514 10.509 4.25812 11.3568C5.3211 12.2045 6.64037 12.6664 8.00002 12.6667ZM8.00002 11C7.20437 11 6.44131 10.6839 5.8787 10.1213C5.31609 9.55871 5.00002 8.79565 5.00002 8C5.00002 7.20435 5.31609 6.44129 5.8787 5.87868C6.44131 5.31607 7.20437 5 8.00002 5C8.79567 5 9.55873 5.31607 10.1213 5.87868C10.6839 6.44129 11 7.20435 11 8C11 8.79565 10.6839 9.55871 10.1213 10.1213C9.55873 10.6839 8.79567 11 8.00002 11ZM8.00002 9.66667C8.44205 9.66667 8.86597 9.49107 9.17853 9.17851C9.49109 8.86595 9.66669 8.44203 9.66669 8C9.66669 7.55797 9.49109 7.13405 9.17853 6.82149C8.86597 6.50893 8.44205 6.33333 8.00002 6.33333C7.55799 6.33333 7.13407 6.50893 6.82151 6.82149C6.50895 7.13405 6.33335 7.55797 6.33335 8C6.33335 8.44203 6.50895 8.86595 6.82151 9.17851C7.13407 9.49107 7.55799 9.66667 8.00002 9.66667Z"
                                    fill="#374253"
                                 />
                              </svg>{" "}
                           </span>
                        )}

                        {/* <span className={"Pw_Icon"} onClick={togglePassword}>
                           <i class="fa-regular fa-eye"></i>{" "}
                        </span> */}
                     </div>
                     <div className={"ForgetPassword_Wrapper_Modal"}>
                        <div className="_checkbox">
                           <label class="myCheckbox">
                              <input
                                 type="checkbox"
                                 name="remember"
                                 id="remember"
                                 className="CheckBox"
                                 checked={rememberMe}
                                 style={{ cursor: "pointer" }}
                                 onChange={(e) => {
                                    setRememberMe(e.target.checked);
                                 }}
                              />
                           </label>
                           <label htmlFor="remember">Keep me signed in</label>
                        </div>
                        <a href="/forgot-password" className={"ForgetPassword_Link"}>
                           Forgot Password ?
                        </a>
                     </div>
                     <button
                        className={"Signin_Button"}
                        onClick={handleSubmit}
                        disabled={btn_state}
                     >
                        Sign in
                     </button>
                     <div className="otp-login">
                        <div>
                           <img
                              style={{ width: "38px", height: "38px" }}
                              src={mobile}
                              alt="Otp Login Icon"
                           />
                        </div>

                        <p>
                           Don’t have a password setup yet? You can also login with{" "}
                           <a
                              id="otp-href"
                              onClick={() => navigate("/otp-login", { replace: true })}
                           >
                              {" "}
                              Verification code
                           </a>
                        </p>
                     </div>
                     {
                        process.env.REACT_APP_ISRECAPTCHA
                        === "true" && (
                           <Captcha reRef={reRef} />
                        )
                     }
                     {/* <a
                        href="/otp-login"
                        className={"ForgetPassword_Link"}
                        style={{
                           color: "#ffff",

                           border: "1px solid grey",
                           borderRadius: "8px",
                           maxWidth: "405px",

                           padding: "10px",
                           textAlign: "center",
                           backgroundColor: "#0E9E49",
                        }}
                     >
                        Verification code
                     </a> */}
                  </div>
               </div>
            </div>
         </Modal.Body>
      </Modal>
   );
};

export default LoginModal;
